import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSnackBar, MatSort } from '@angular/material';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { PagingAndSortParams } from '@ig-core/list/paging-and-sort-params';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReferenceCodeSearchCriteria } from '@app/admin/reference-code/reference-code.model';
import { ApplicationService } from '@app/applications/application.service';
import { PartyInfoDTO } from '@app/applications/application-details/financials/dossier/dossier.model';
import { XDataRequestGroup, XDSRegistry } from '@app/applications/application-details/applicationDocument/xdata-service/xdata-registry.model';
import { HttpResponse } from '@angular/common/http';
import { DataSourceService } from '../data-source.service';

@Component({
    selector: 'app-data-source',
    templateUrl: 'data-source.component.html',
    styleUrls: ['../data-source.component.scss']
})
export class DataSourcingCallComponent implements OnInit {

    pagingAndSortParams: PagingAndSortParams;


    @ViewChild(MatPaginator)
    paginator: MatPaginator;

    @ViewChild(MatSort)
    sort: MatSort;

    serviceRegistryRecord: XDSRegistry[];

    // search criteria
    refCodeSearchForm: FormGroup;
    referenceCodeSearchCriteria: ReferenceCodeSearchCriteria;
    pageNumbers: any;
    recentRequests: XDataRequestGroup[];
    requestType: string[];
    partyPlays: PartyInfoDTO[];
    historyRecords: any;
    showHistory: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private applicationService: ApplicationService,
        private _snackbar: MatSnackBar,
        private dataSourceService: DataSourceService) { }

    ngOnInit() {
        this.showHistory = false;
        this.refCodeSearchForm = this.formBuilder.group({
            uid: '',
            serviceType: ''
        });

        this.applicationService.getXDataServices()
            .subscribe((response: any) => {
                this.serviceRegistryRecord = response.body;
            })
    }

    getXdataRequest() {
        this.showHistory = false;
        this.recentRequests = null;
        let applicationUid = this.refCodeSearchForm.value.uid.trim();
        this.requestType = [this.refCodeSearchForm.value.serviceType];
        if(!applicationUid){
            this._snackbar.open("Application uid is required " , "close", {
                duration: 4000
            })
            return;
        }
        this.dataSourceService.findXdataRequest(applicationUid, this.requestType).subscribe(response => {
            this.recentRequests = response.body;
            this.getPartyPlays(applicationUid);
        })
    }

    getPartyPlays(applicationUid) {
        let partyPlays = 'applicant,coapplicant,business';
        this.applicationService.getParties(applicationUid, partyPlays).subscribe((response: any) => {
            this.partyPlays = response.body;
            this.setMatchingPartiesNameAndType()
        })
    }

    setMatchingPartiesNameAndType() {
        this.recentRequests.forEach(requestGroup => {
            requestGroup.xdataRequestDTOs.forEach(ele => {
                // for "ekyc" request made form web-app linkToUid won't be present, hence we are setting value present in name field,
                // if linkToUid is present and matching partyPlay is found then we are replacing with matching borrower name.
                if("ekyc" === requestGroup.requestType.toLocaleLowerCase()){
                    ele.partyName = ele.name;
                }
                const matchingParty = this.partyPlays.find(party => party.uid === ele.linkToUid);
                if (matchingParty) {
                    ele.partyName = matchingParty.name;
                    ele.partyType = matchingParty.partyPlay;
                }
            });
        });
    }

    recoverRequestData(data) {
        this.dataSourceService.generateRequestFile(data.id)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(response => {
                this.saveDownloadedRequestFile(response);
            }, (failure) => {
                this._snackbar.open(failure, "close", {
                    duration: 6000,
                })
            })
    }

    saveDownloadedRequestFile(response: HttpResponse<any>) {
        const url = window.URL.createObjectURL(response.body);
        console.log("headder", response.headers);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = url;
        const responseHeaderFilename = response.headers.get('Content-Disposition');
        var filename = responseHeaderFilename.split(';')[1].split('=')[1].trim();
        a.download = filename
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    showHistoryRecords(request){
        this.showHistory = true;
        this.historyRecords = request;
    }

    close(){
        this.showHistory = false;
    }

    ngOnDestroy(): void {
    }

}
